import { Form, Formik } from 'formik';
import i18n from '../../i18n';
import styles from '../EventSubmissionForm/EventSubmissionForm.module.scss';
import { InputGroupV2, PrevAndSubmitButtons } from './EventSubmissionFormV2';

const AboutStep = ({ initialValues, validationSchema, onSubmit }) => {
    return (
        <>
            <Formik
                initialValues={initialValues}
                validationSchema={validationSchema}
                onSubmit={onSubmit}>
                {() => (
                    <Form className={styles['EventSubmissionForm--V2']}>
                        <legend
                            className={
                                styles['EventSubmissionForm__SectionHeader'] +
                                ' ' +
                                styles[
                                    'EventSubmissionForm__SectionHeader--Required'
                                ]
                            }>
                            {i18n.t(
                                'EventSubmissionFormV2.sectionHeaderNameEn'
                            )}
                        </legend>
                        <InputGroupV2
                            name="titleEn"
                            type="text"
                            placeholder={i18n.t(
                                'EventSubmissionForm.labels.titleEn'
                            )}
                            infoMessage={i18n.t(
                                'EventSubmissionForm.labels.titleEnInfo'
                            )}
                        />
                        <InputGroupV2
                            name="descriptionEn"
                            placeholder={i18n.t(
                                'EventSubmissionForm.labels.descriptionEn'
                            )}
                            type="textarea"
                        />
                        <legend
                            className={
                                styles['EventSubmissionForm__SectionHeader'] +
                                ' ' +
                                styles[
                                    'EventSubmissionForm__SectionHeader--Required'
                                ] +
                                ' ' +
                                styles[
                                    'EventSubmissionForm__SectionHeader--MarginTop'
                                ]
                            }>
                            {i18n.t(
                                'EventSubmissionFormV2.sectionHeaderNameSv'
                            )}
                        </legend>
                        <InputGroupV2
                            name="titleSv"
                            placeholder={i18n.t(
                                'EventSubmissionForm.labels.titleSv'
                            )}
                            type="text"
                            infoMessage={i18n.t(
                                'EventSubmissionForm.labels.titleSvInfo'
                            )}
                        />
                        <InputGroupV2
                            name="descriptionSv"
                            placeholder={i18n.t(
                                'EventSubmissionForm.labels.descriptionSv'
                            )}
                            type="textarea"
                        />
                        <PrevAndSubmitButtons onlySubmit />
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default AboutStep;
